import { render, staticRenderFns } from "./TicketsNav.vue?vue&type=template&id=00bfbba2&scoped=true&"
import script from "./TicketsNav.vue?vue&type=script&lang=js&"
export * from "./TicketsNav.vue?vue&type=script&lang=js&"
import style0 from "./TicketsNav.vue?vue&type=style&index=0&id=00bfbba2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bfbba2",
  null
  
)

export default component.exports